import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import useRouteMeta from '../../../hooks/useRouteMeta';
import './PricingNew.css';

const PricingNew = () => {
    // SEO Meta Tags
    useRouteMeta();

    // Scroll to top on page load
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const subscriptionPlans = [
        {
            id: 'lite',
            name: 'Lite',
            monthlyPrice: '₹ 999/month',
            monthlyCredits: '1000 Tokens',
            yearlyPrice: '₹ 9,999/year',
            yearlyCredits: '12000 Tokens',
            discount: '20% More',
            popular: false,
            bestValue: false,
            borderColor: '#1E4966',
            topBorderColor: '#1E4966',
            discountBgColor: '#1E4966',
            innerBorderColor: '#d6d3e1',
            checkmarkColor: '#1E4966',
            features: [
                'Bulk Upload',
                'PDF Catalogue Downloads',
                'Web Catalogues',
            ],
        },
        {
            id: 'growth',
            name: 'Growth',
            monthlyPrice: '₹ 2,499/month',
            monthlyCredits: '2500 Tokens',
            yearlyPrice: '₹ 24,999/year',
            yearlyCredits: '30,000 Tokens',
            discount: '20% More',
            popular: false,
            bestValue: false,
            borderColor: '#882DC0',
            topBorderColor: '#882DC0',
            discountBgColor: '#882DC0',
            innerBorderColor: '#882DC0',
            checkmarkColor: '#882DC0',
            features: [
                'Bulk Upload',
                'PDF Catalogue Downloads',
                'Web Catalogues',
                'Reels',
            ],
        },
        {
            id: 'pro',
            name: 'Pro',
            monthlyPrice: '₹ 6,999/month',
            monthlyCredits: '7000 Tokens',
            yearlyPrice: '₹ 69,999/year',
            yearlyCredits: '84,000 Tokens',
            discount: '20% More',
            popular: true,
            bestValue: false,
            borderColor: '#D9627F',
            topBorderColor: '#D9627F',
            discountBgColor: '#D9627F',
            innerBorderColor: '#D9627F',
            checkmarkColor: '#D9627F',
            features: [
                'Bulk Upload',
                'PDF Catalogue Downloads',
                'Web Catalogues',
                'Reels',
                'Premium Shots',
                'UGC Videos',
            ],
        },
        {
            id: 'enterprise',
            name: 'Enterprise',
            monthlyPrice: 'Contact Us',
            monthlyCredits: '',
            yearlyPrice: '',
            yearlyCredits: '',
            discount: '',
            popular: false,
            bestValue: true,
            borderColor: '#F5CA02',
            topBorderColor: '#F5CA02',
            discountBgColor: '#F5CA02',
            innerBorderColor: '#F5CA02',
            checkmarkColor: '#F5CA02',
            features: [
                'Bulk Upload',
                'PDF Catalogue Downloads',
                'Web Catalogues',
                'Reels',
                'API',
                'Integration with other CRMs/Partners',
            ],
        },
    ];

    const photoCreationPricing = [
        { contentType: 'Bust Image', standard1k: '₹20', standard2k: '₹35', standard4k: '₹80' },
        { contentType: 'Human Image', standard1k: '₹40', standard2k: '₹50', standard4k: '₹150' },
        { contentType: 'Bust Video', standard1k: '—', standard2k: '₹225', standard4k: '₹750' },
        { contentType: 'Human Video', standard1k: '—', standard2k: '₹325', standard4k: '₹1,200' },
        { contentType: 'Poster / Social Image', standard1k: '—', standard2k: '₹150', standard4k: '₹300' },
        { contentType: 'Product Photoshoot w/ Props', standard1k: '₹30', standard2k: '₹40', standard4k: '₹300' },
        { contentType: 'Plain White Product Photos', standard1k: '₹20', standard2k: '₹35', standard4k: '₹80' },
        { contentType: 'Reel Creation', standard1k: '', standard2k: '₹50', standard4k: '' },
    ];

    return (
        <div className="pricing-new-page">
            <Header />

            {/* Subscription Packages Section */}
            <section className="pn-section pn-packages">
                <div className="container">
                    <div className="pn-section-header">
                        <div className="pn-section-badge">Subscription Packages</div>
                    </div>

                    <div className="pn-plans-grid">
                        {subscriptionPlans.map((plan) => (
                            <div key={plan.id} className="pn-plan-card" style={{ '--border-color': plan.borderColor, '--top-border-color': plan.topBorderColor, '--accent-color': plan.borderColor, '--discount-color': plan.discountBgColor, '--checkmark-color': plan.checkmarkColor, '--inner-border-color': plan.innerBorderColor }}>
                                {plan.popular && <div className="pn-badge pn-badge-popular">♥ Most Popular</div>}
                                {plan.bestValue && <div className="pn-badge pn-badge-best">★ Best Value</div>}

                                <h3 className="pn-plan-name">{plan.name}</h3>

                                <div className="pn-pricing-section">
                                    {plan.monthlyPrice === 'Contact Us' ? (
                                        <button className="pn-btn pn-btn-contact">
                                            <span className="btn-text">Contact Us</span>
                                        </button>
                                    ) : (
                                        <div className="pn-pricing-box">
                                            <div className="pn-price-row">
                                                <span className="pn-price">{plan.monthlyPrice}</span>
                                                <span className="pn-credits">{plan.monthlyCredits}</span>
                                            </div>

                                            <div className="pn-price-divider" />

                                            <div className="pn-price-row pn-yearly">
                                                <span className="pn-price">{plan.yearlyPrice}</span>
                                                <span className="pn-credits">{plan.yearlyCredits}</span>
                                            </div>

                                            {plan.discount && (
                                                <div className="d-flex justify-content-center">
                                                    <div className="pn-discount-badge">{plan.discount}</div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="pn-features">
                                    <div
                                        className={`${plan.name === 'Enterprise'
                                            ? 'pn-addons-label2'
                                            : 'pn-addons-label'
                                            }`}
                                    >
                                        Add-Ons included
                                    </div>                  <ul>
                                        {plan.features.map((feature, idx) => (
                                            <li key={idx} style={{ '--checkmark-color': plan.checkmarkColor }}>
                                                <span className="pn-check-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="12" cy="12" r="11" fill="var(--checkmark-color)" stroke="var(--checkmark-color)" strokeWidth="1.5" />
                                                        <path d="M7 12.5L10.2 15.5L17 8.5" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Photo Creation Pricing Section */}
            <section className="pn-section pn-photo-pricing">
                <div className="container">
                    <div className="pn-section-header">
                        <div className="pn-section-badge">Photo Creation Pricing</div>
                    </div>

                    <div className="pn-table-responsive">
                        <table className="pn-pricing-table table-bordered">
                            <thead>
                                <tr>
                                    <th>Content Type</th>
                                    <th>Standard 1K</th>
                                    <th>Standard 2K</th>
                                    <th>Standard 4K</th>
                                </tr>
                            </thead>
                            <tbody>
                                {photoCreationPricing.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="pn-content-type">{row.contentType}</td>
                                        {row.contentType === 'Reel Creation' ? (
                                            <td colSpan="3" className="pn-reel-price">{row.standard2k}</td>
                                        ) : (
                                            <>
                                                <td>{row.standard1k}</td>
                                                <td>{row.standard2k}</td>
                                                <td>{row.standard4k}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default PricingNew;
